import { emailIsSuperAppAdmin } from "@common/utils/email";

export const isProdEnv = () => {
  return process.env.NEXT_PUBLIC_NODE_ENV
    ? process.env.NEXT_PUBLIC_NODE_ENV.startsWith("prod")
    : process.env.NODE_ENV
    ? process.env.NODE_ENV.startsWith("prod")
    : false;
};

export const isTestEnv = () => {
  return process.env.NEXT_PUBLIC_NODE_ENV
    ? process.env.NEXT_PUBLIC_NODE_ENV.startsWith("test")
    : process.env.NODE_ENV
    ? process.env.NODE_ENV.startsWith("test")
    : false;
};

export const isDevEnv = () => {
  return process.env.NEXT_PUBLIC_NODE_ENV
    ? process.env.NEXT_PUBLIC_NODE_ENV.startsWith("dev")
    : process.env.NODE_ENV
    ? process.env.NODE_ENV.startsWith("dev")
    : false;
};

export const isTestOrDevEnv = () => {
  return isTestEnv() || isDevEnv();
};

export const isTestDevOrSuperAppAdmin = (email?: string) => {
  return isTestOrDevEnv() || emailIsSuperAppAdmin(email);
};

// Public self-signup kill switch. Enabled by default; set NEXT_PUBLIC_SIGNUP_ENABLED="false"
// to turn off self-registration without a code change. Because it is a NEXT_PUBLIC_ var it is
// readable from both the client (signin page, /try) and the server (register route) from one
// source, so the UI link, the /try page, and the /api/register backend can't drift apart.
export const signupEnabled = () => {
  return process.env.NEXT_PUBLIC_SIGNUP_ENABLED !== "false";
};
